import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';


import { ViewController } from 'ionic-angular';

/**
 * Generated class for the BusquedaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-busqueda',
  templateUrl: 'busqueda.html',
})
export class BusquedaPage {
	datos: any ;
	filtro: any = '';
	datosOriginal: any;
	campoBusqueda: any;



  constructor(public navCtrl: NavController
  	, public navParams: NavParams
  	, public viewCtrl: ViewController) {

  	this.campoBusqueda = this.navParams.get('campobus').split(',');
    this.datosOriginal=this.datos= this.navParams.get('parametro');
  }

  ionViewDidLoad() {
  }
  filtrarTexto()
  {

  	this.datos =this.datosOriginal.filter(elemento => {
      
      for (var i = 0; i < this.campoBusqueda.length; ++i) {
        if(elemento[this.campoBusqueda[i]]!= null && elemento[this.campoBusqueda[i]].toUpperCase().indexOf(this.filtro.toUpperCase())>-1) return true;
      }
      return false;

      //this.campoBusqueda.forEach(x => { 
      //  console.log(elemento[x])
      //  return elemento[x].toUpperCase().indexOf(this.filtro.toUpperCase())>-1 
      //})
      //elemento[this.campoBusqueda[0]].toUpperCase().indexOf(this.filtro.toUpperCase())>-1
    });

  }

  itemClick(evento, item)
  {
  		this.viewCtrl.dismiss(item);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/busqueda/busqueda.ts